import React, { useState } from 'react';

import { useFormikContext } from 'formik';

import FullScreenToolTip from 'components/FullScreenToolTip';
import Input from 'components/Input';
import CurrencyInput from 'containers/CurrencyInput';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Header, Body, StyledField as Field } from './styles';

export enum Type {
  National = 'national',
  International = 'international',
}

interface Props {
  type: Type;
  isTourTooltip?: boolean;
}

const FlightRestriction = ({ type }: Props) => {
  const { t } = useStoreTranslation();
  const [showFlightTaxToolTip, setShowFlightTaxToolTip] = useState(false);
  const formik = useFormikContext();

  const handleRemoveFlexibilityMask = (value: string) => value.replace('+ ', '');

  return (
    <Container>
      <Header>
        <Header.Title>
          {t(
            type === Type.National
              ? 'rule.restriction.flight.titleNational'
              : 'rule.restriction.flight.titleInternational',
          )}
        </Header.Title>
      </Header>
      <Body>
        <Field name={`${type}FlightAnticipation`} label={t('rule.restriction.anticipation')}>
          <Input
            suffix={t('rule.restriction.anticipationSuffix')}
            darkPlaceholder
            placeholder={t('rule.restriction.withoutRestriction')}
            onBlur={(e) => {
              if (e.currentTarget.value === '0') {
                formik.setFieldValue(`${type}FlightAnticipation`, '');
              }
            }}
          />
        </Field>
        <Field
          name={`${type}FlightMaxPrice`}
          label={t('rule.restriction.maxPrice')}
          simpleTooltip
          simpleTooltipText={t('rule.tour.flightMaxPrice')}
        >
          <CurrencyInput darkPlaceholder placeHolder={t('rule.restriction.withoutRestriction')} />
        </Field>
        <Field
          name={`${type}FlightFlexibility`}
          label={t('rule.restriction.flexibility')}
          removeMask={handleRemoveFlexibilityMask}
          tooltip
          tooltipTarget="target-flightTax"
          tooltipClick={() => setShowFlightTaxToolTip(true)}
        >
          <Input suffix="%" darkPlaceholder placeholder={t('rule.restriction.withoutRestriction')} mask="+ 999" />
        </Field>
        <FullScreenToolTip
          show={showFlightTaxToolTip}
          onClose={() => setShowFlightTaxToolTip(false)}
          title={t('rule.tour.flightTaxTitle')}
          items={[
            {
              icon: '/corporate/images/calculator-colored.svg',
              text: t('rule.tour.flightTax'),
            },
          ]}
        />
      </Body>
    </Container>
  );
};

export default FlightRestriction;
